import * as React from 'react';
import { Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Logout from '@mui/icons-material/Logout';
import authSlice from 'store/slices/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';

type Props = {
  accountMenuAnchorEl: null | HTMLElement;
  setAccountMenuAnchorEl: (el: null | HTMLElement) => void;
};
export default function AccountDropdownMenu(props: Props) {
  const { accountMenuAnchorEl, setAccountMenuAnchorEl } = props;
  const handleAccountMenuClose = () => setAccountMenuAnchorEl(null);

  const user = useSelector((state: RootState) => state.auth.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMyProfile = () => navigate(`/home/users/${user?.id}`);
  const handleLogout = () => dispatch(authSlice.actions.logout());

  return (
    <Menu
      anchorEl={accountMenuAnchorEl}
      id="account-menu"
      open={!!accountMenuAnchorEl}
      onClose={handleAccountMenuClose}
      onClick={handleAccountMenuClose}
      PaperProps={{
        elevation: 0,
        style: {
          transform: 'translateX(-6px)',
        },
        sx: {
          'overflow': 'visible',
          'filter': 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          'mt': 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
    >
      <MenuItem onClick={handleMyProfile}>
        <ListItemIcon>
          <PersonIcon fontSize="small" />
        </ListItemIcon>
        My Profile
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
}
